import { applicationStore } from "src/store/ApplicationStore";

export function useClientBranding() {
  return applicationStore.clientBranding;
}
